import { NgModule } from '@angular/core';

import { EChartsDirective } from './echarts.directive';
import { SlimScrollDirective } from './slim-scroll.directive';
import { MdDatepickerModule } from '@angular/material';

@NgModule({
    imports: [MdDatepickerModule],
    declarations: [
        EChartsDirective,
        SlimScrollDirective,
    ],
    exports: [
        EChartsDirective,
        SlimScrollDirective,
    ]
})

export class SharedModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/shared.module.ts